<template>
    <h6 class="mb-2 text-center">
        {{ $gettextInterpolate($gettext('Apps for your search: "%{searchTerm}"'), {searchTerm}) }}
    </h6>
</template>

<script>
export default {
    name: 'DeviceSearchingText',
    props: {
        searchTerm: {
            default: '',
            required: true,
            type:String
        }
    }
}
</script>
